// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"aedf2524","833":"b59b3460","952":"74ff31ff"}[chunkId] + ".chunk.js";
};